import { DynamicFormConfig, FieldTypeEnum, FlexLayoutConfig, SlideToggleFieldConfig, TextFieldConfig } from "@mydocma/dynamic-form";
import { SelectFieldConfig } from "@mydocma/dynamic-form/lib/fields/select/select-field.config";

export enum FooterHeaderFieldEnum {
  header = 'header',
  footerLeft = 'footerLeft',
  footerCenter = 'footerCenter',
  projectNumber = 'projectNumber',
  projectTitle = 'projectTitle',
  date = 'date',
  user = 'user'
}

export const headerFieldConfig: TextFieldConfig = {
  id: FooterHeaderFieldEnum.header,
  name: FooterHeaderFieldEnum.header,
  label: {
    text: 'MM.report.tabs.options.header'
  },
  type: FieldTypeEnum.text,
};

export const headerFooterLeftFieldConfig: TextFieldConfig = {
  id: FooterHeaderFieldEnum.footerLeft,
  name: FooterHeaderFieldEnum.footerLeft,
  label: {
    text: 'MM.report.tabs.options.footerLeft'
  },
  type: FieldTypeEnum.text,
};

export const headerFooterCenterFieldConfig: TextFieldConfig = {
  id: FooterHeaderFieldEnum.footerCenter,
  name: FooterHeaderFieldEnum.footerCenter,
  label: {
    text: 'MM.report.tabs.options.footerRight'
  },
  type: FieldTypeEnum.text,
};

export const headerProjectNumberFieldConfig: SlideToggleFieldConfig = {
  id: FooterHeaderFieldEnum.projectNumber,
  name: FooterHeaderFieldEnum.projectNumber,
  label: {
    text: 'MM.report.tabs.options.projectNumber'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};

export const headerProjectTitleFieldConfig: SlideToggleFieldConfig = {
  id: FooterHeaderFieldEnum.projectTitle,
  name: 'projectTitle',
  label: {
    text: 'MM.report.tabs.options.projectTitle'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};

export const headerDateFieldConfig: SlideToggleFieldConfig = {
  id: FooterHeaderFieldEnum.date,
  name: 'date',
  label: {
    text: 'MM.report.tabs.options.date'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};


export const headerUserFieldConfig: SlideToggleFieldConfig = {
  id: FooterHeaderFieldEnum.user,
  name: 'user',
  label: {
    text: 'MM.report.tabs.options.user'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
}

export const footerLayout: FlexLayoutConfig = {
  name: 'footerLayout',
  cols: [
    {
      col: 0,
      flex: '50'
    },
    {
      col: 1,
      flex: '50'
    }
  ],
  rows: [],
  fields: [
    {
      fieldName: FooterHeaderFieldEnum.projectNumber,
      col: 0,
      row: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.projectTitle,
      col: 1,
      row: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.header,
      col: 0,
      row: 1,
      layoutAlign: 'start center',
      maxCollapsedWidth: 0,
      flex: '100',
      class: 'footer-header-text-field-xl'
    },
    {
      fieldName: FooterHeaderFieldEnum.footerLeft,
      col: 0,
      row: 2,
      flex: '70',
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.user,
      col: 1,
      row: 2,
      flex: '30',
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.footerCenter,
      col: 0,
      row: 3,
      flex: '70',
      layoutAlign: 'start center'
    },{
      fieldName: FooterHeaderFieldEnum.date,
      col: 1,
      row: 3,
      flex: '30',
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    }

  ]
}


export const footerLayoutMobile: FlexLayoutConfig = {
  name: 'footerLayoutMobile',
  cols: [
    {
      col: 0,
      flex: '60'
    },
    {
        col: 1,
        flex: '40'
    }
  ],
  rows: [
    {
      row: 0
    },
    {
      row: 1
    },
    {
      row: 2
    },
    {
      row: 3
    },
    {
      row: 4
    }
  ],
  fields: [
    {
      fieldName: FooterHeaderFieldEnum.projectNumber,
      col: 0,
      row: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.projectTitle,
      col: 0,
      row: 1,
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.header,
      col: 0,
      row: 2,
      flex: '100',
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.footerLeft,
      col: 0,
      row: 3,
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.user,
      col: 1,
      row: 3,
      layoutAlign: 'start center'
    },
    {
      fieldName: FooterHeaderFieldEnum.footerCenter,
      col: 0,
      row: 4,
      layoutAlign: 'start center'
    },{
      fieldName: FooterHeaderFieldEnum.date,
      col: 1,
      row: 4,
      layoutAlign: 'start center'
    }
  ]

}

export const footerHeaderFormConfig: DynamicFormConfig = {
  fields: [
    headerFieldConfig,
    headerFooterLeftFieldConfig,
    headerFooterCenterFieldConfig,
    headerProjectNumberFieldConfig,
    headerProjectTitleFieldConfig,
    headerDateFieldConfig,
    headerUserFieldConfig
  ],
  layouts: [footerLayout, footerLayoutMobile],
};
